import { render, staticRenderFns } from "./HelpIsOnTheWayPage.vue?vue&type=template&id=af7c75c2&scoped=true&"
import script from "./HelpIsOnTheWayPage.vue?vue&type=script&lang=js&"
export * from "./HelpIsOnTheWayPage.vue?vue&type=script&lang=js&"
import style0 from "./HelpIsOnTheWayPage.vue?vue&type=style&index=0&id=af7c75c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7c75c2",
  null
  
)

export default component.exports